import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';

import { useRelatedCallsContext } from 'lib/common/contexts/RelatedCallsContext';
import { useLayout } from 'lib/common/contexts/layout/LayoutContext';

import Icon from 'lib/common/components/Icon';
import Text from 'lib/common/components/Text';
import Checkbox from 'lib/common/components/atoms/Checkbox';

import styles from './related-calls-checkbox.module.scss';

export default function RelatedCallsCheckbox({
  activeCallName,
  onActiveCall,
  isDialpadTransfer,
}: {
  activeCallName?: string;
  onActiveCall: boolean;
  isDialpadTransfer?: boolean;
}) {
  const { isSoftphone } = useLayout();
  const {
    state: { canRelateCall, isRelatingCall, lastCallWith },
    actions: { setIsRelatingCall },
  } = useRelatedCallsContext();

  if (!canRelateCall || !isSoftphone || isDialpadTransfer) {
    return null;
  }

  const currentOrPreviousCall = onActiveCall ? 'current' : 'previous';

  return (
    <div className={styles['related-calls-checkbox']}>
      <Checkbox
        checked={isRelatingCall}
        onChange={() => setIsRelatingCall(!isRelatingCall)}
        ariaLabel={`Link to your ${currentOrPreviousCall} call. We'll automatically link this new outbound call to your ${currentOrPreviousCall} call with ${onActiveCall ? activeCallName : lastCallWith}.`}
        label={
          <Text
            inline="flex"
            className="flex next-to-5"
            suffix={
              <Icon
                size={15}
                color="darkGrey"
                icon={faCircleQuestion}
                tooltip={`We'll automatically link this new outbound call to your ${currentOrPreviousCall} call with ${onActiveCall ? activeCallName : lastCallWith}.`}
              />
            }
          >
            Link to your {currentOrPreviousCall} call
          </Text>
        }
      />
    </div>
  );
}
